const {
  getContentValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * Provides the Pass Type options
 * (under the Add Pass button in the Weld Passes section)
 * according to which WPS is selected in the General section.
 *
 * @function evalute - evaluate ucbWeldPassTypeOptionsBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const weldPassType = getContentValue('/general/weldPassType', content) || {};
  const [uuid] = Object.keys(weldPassType);
  const formQuery = {
    type: 'getFormContentBehavior',
    entityName: 'Form',
    uuid
  };
  const formContent = await sourceEvaluator(formQuery);
  const presets = getContentValue('/general/presets', formContent) || {};
  const weldPasses = getContentValue('/weldPasses', content) || {};
  Object.keys(weldPasses).forEach(key => {
    if (presets[key] !== undefined) {
      delete presets[key];
    }
  });
  return {
    title: 'Pass Types',
    options: presets,
    placeholder: 'Please add further Pass Types in the Admin area.'
  };
};
module.exports = {
  evaluate
};